import React, { useState } from "react";
import { Row, Col, Modal,ModalHeader,ModalBody  } from "react-bootstrap";
import "../scss/claimbulkprocess.scss";
import { REACT_APP_VAM_CONTEXT_APPROVAL, REACT_APP_VAM_ENDPOINT } from "../urls";
import { toast } from "react-toastify";
import Colors from "../utilsComponent/colors";
import { axiosRequest } from "../service";

const RunNumberDetails = (props) => {
  const [runNumber, setRunNumber] = useState("")
  const [runNumberStatusModal, setRunNumberStatusModal] = useState(false)
  const [runNumberData, setRunNumberData] = useState({})


  const searchRunNumberStatus = () => {
    if(!runNumber){
      toast.error("Please Enter Run Number.")
      return
    }
    axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_APPROVAL}/status/${runNumber}`).then(data => {
      setRunNumberData(data.data)    
      setRunNumberStatusModal(true)
    }).catch(error => {
        console.log(error)
    })
  } 
 
  return (
    <section className="p-4">
      <div className="border rounded p-4 px-1">
        <div className="d-md-flex align-items-center justify-content-around">
        <Row>
            <Col xs={3} className="form-group w-20">
            <label for="exampleInputPassword1">Run Number</label>
                  <input type="text" className="form-control bg-white" id="exampleInputPassword1" placeholder="Enter Run Number" value={runNumber}  onChange={(e) => {
                          setRunNumber(e.target.value)
                        }}/>
            </Col >
          </Row>
        </div>
            <Row>
              <div className="form-group">
                <button className="btn btn-success m-4 mb-0 px-4" onClick={() => searchRunNumberStatus()}>Search</button>
                <button className="btn btn-outline-success mt-4 mb-0 px-4" onClick={() => {setRunNumber("")}}>Reset</button>
              </div>
            </Row>
      </div>

      {
        runNumberStatusModal && (
        <Modal show={runNumberStatusModal} isOpen={runNumberStatusModal} centered={true} backdrop={'static'}>
          <ModalHeader className="text-primary">Run Number Details
          <span ><button type="button" className="btn-close" aria-label="Close" onClick={() => { setRunNumberStatusModal(false) }}></button></span>
          </ModalHeader>
          <ModalBody>
          <table id="claim_historyclaim">
            <tbody>
              <tr>
                <th>
                  ID
                </th>
                <th>
                  Run Number
                </th>
                <th>
                  Status
                </th>
              </tr>
                <tr>
                  <td>{runNumberData.id}</td>
                  <td>{runNumberData.runNumber}</td>
                  <td>{<Colors status={runNumberData.status} />}</td>
                </tr>
            </tbody>
          </table>
          </ModalBody>
          {/* <ModalFooter style={{ justifyContent: 'center' }}>
            <Button color="secondary" style={{ borderColor: 'red', backgroundColor: 'transparent', color: 'red' }} onClick={() => setRunNumberStatusModal(false)}>Cancel</Button>
          </ModalFooter> */}
        </Modal>
        )
      }
    </section>
  )
}
export default RunNumberDetails;